import { Button } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
	&&& {
		.MuiList-root {
			background-color: ${({ theme }) => theme.pantone657C};
		}

		.mui-poper-register {
			z-index: 10;
		}
	}
`;
export const SubPage = styled.span`
	color: ${({ theme }) => theme.white};

	:hover {
		filter: brightness(0.5);
	}
`;

export const StyledButton = styled(Button)`
	&&& {
		color: ${({ theme }) => theme.white};
		padding: 0;
		text-transform: none;
		font-size: 1rem;

		:hover {
			filter: brightness(0.5);
		}
	}
`;
